import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { startSincronizzaAlias } from 'uniba-volto-persone/actions';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { Icon } from 'design-react-kit';

class SincronizzaAliasToolbar extends Component {
    componentDidUpdate(prevProps) {
        const { toast } = this.props.toastify;
        const currentPath = this.currentPath;
        const prevResult = prevProps.sincronizzaAliasReducer?.[currentPath];
        const currentResult = this.props.sincronizzaAliasReducer?.[currentPath];

        if (currentResult && currentResult !== prevResult) {
            const resMsg = currentResult.msg?.toString() || 'Errore sconosciuto';
            if (currentResult.result === true) {
                toast.success(`Sincronizza Alias completato con successo: ${resMsg}`);
            } else {
                toast.error(`Errore nel Sincronizza Alias: ${resMsg}`);
            }
        }
    }

    hasPermissions() {
        const { actions } = this.props;
        return actions?.user?.some((ua) => ua?.id === 'toolbar-sincronizza-alias');
    }

    getCurrentPath() {
        const { breadcrumbs } = this.props;
        return breadcrumbs?.length > 0
            ? breadcrumbs[breadcrumbs.length - 1]?.url
            : '/';
    }

    handleClick = (e) => {
        e.preventDefault();
        const path = this.getCurrentPath();
        this.currentPath = path;
        this.props.startSincronizzaAlias(path);
    };

    render() {
        if (!this.hasPermissions()) return null;

        const { intl } = this.props;
        const toolbar_title = intl.formatMessage({ id: 'sincronizza_alias' });

        return (
            <Plug pluggable="main.toolbar.top" id="sincronizza-alias-toolbar">
                <Link
                    to="#"
                    onClick={this.handleClick}
                    aria-label={toolbar_title}
                    alt={toolbar_title}
                    title={toolbar_title}
                    tabIndex={0}
                    className="deleteBlocks"
                    id="toolbar-sincronizza-alias"
                >
                    <Icon icon="it-exchange-circle" color="secondary" size="md" title={toolbar_title} alt={toolbar_title} />
                </Link>
            </Plug>
        );
    }
}

const mapStateToProps = (state) => ({
    actions: state?.actions?.actions,
    breadcrumbs: state.breadcrumbs.items || [],
    sincronizzaAliasReducer: state.sincronizzaAliasReducer?.items || {}
});

const mapDispatchToProps = {
    startSincronizzaAlias,
};

export default injectLazyLibs(['toastify'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
        (injectIntl(
            SincronizzaAliasToolbar
        ))
);
